import Head from "next/head";
import { parseDataCurrencies } from 'helpers';

const LdjsonMonetaryAmount = ({data, usdBlueTourist}) => {
  const { primary } = parseDataCurrencies(data, usdBlueTourist);

  const itemListElement = primary?.map((currency) => {
    return {
      "@type": "ExchangeRateSpecification",
      "name": currency?.description,
      "currency": currency?.symbol,
      "currentExchangeRate": [{
        "@type": "UnitPriceSpecification",
        "price": currency?.buyingRate,
        "priceType": "Compra",
        "priceCurrency": "ARS",
      },
      {
        "@type": "UnitPriceSpecification",
        "price": currency?.sellingRate,
        "priceType": "Venta",
        "priceCurrency": "ARS"
      }]
    }
  })
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Cotización de Monedas en Clarin.com",
    "mainEntity": {
      "@type": "ItemList",
      "name": "Cotización de Monedas en Clarin.com",
      itemListElement
    }
  };

  return (
    <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
    </Head>
  );
};

export default LdjsonMonetaryAmount;
